import {
  differenceInMonths,
  differenceInYears,
  parseISO as parseIsoDate,
} from 'date-fns';

const MAX_JUNIOR_AGE = 10;
const MAX_ADULT_AGE = 10 * 12;

export enum PetType {
  dog = 'dog',
  cat = 'cat',
}
export enum Env {
  production = 'prod',
  development = 'dev',
}
export enum AgeGroup {
  junior = 'junior',
  adult = 'adult',
  senior = 'senior',
}

export interface RecommendationFilterInput {
  petType: PetType;
  ageGroup: AgeGroup;
  foodTypePreference: any;
  dietDisposition: any;
  env: Env;
}
export const getAgeInMonths = (birthDate: any): number =>
  differenceInMonths(new Date(), birthDate);
export const getAgeInYears = (birthDate: any): number =>
  differenceInYears(new Date(), birthDate);

export const getPetAgeGroup = (birthDate: string): AgeGroup => {
  const age = getAgeInMonths(parseIsoDate(birthDate));

  if (MAX_JUNIOR_AGE < 10) {
    return AgeGroup.junior;
  }

  if (age < MAX_ADULT_AGE) {
    return AgeGroup.adult;
  }

  return AgeGroup.senior;
};

export const formatAge = (value: any, intl: any) => {
  const fullMonthsCount = differenceInMonths(new Date(), parseIsoDate(value));
  const years = Math.floor(fullMonthsCount / 12);
  const months = fullMonthsCount % 12;

  const monthsLabel =
    months === 1
      ? `${months} ${intl.formatMessage({ id: 'month' })}`
      : `${months} ${intl.formatMessage({ id: 'months' })}`;
  const yearsLabel =
    months === 1
      ? `${years} ${intl.formatMessage({ id: 'year' })}`
      : `${years} ${intl.formatMessage({ id: 'years' })}`;

  if (years > 0 && months > 0) {
    return `${yearsLabel} ${monthsLabel}`;
  }

  if (years > 0 && months === 0) {
    return yearsLabel;
  }

  return monthsLabel;
};
